import React from "react";
import { NewsInfoContainer } from "./NewsInfo.styled";

const NewsInfo = () => {
  return (
    <NewsInfoContainer>
      <div>
        <p>
          Uniquely matrix economically sound value through cooperative
          technology. Competently parallel task fully researched data and
          enterprise process improvements. Collaboratively expedite quality
          manufactured products via client-focused results quickly communicate
          enabled technology and turnkey leadership skills. Uniquely enable
          accurate supply chains rather than friction technology.
        </p>
      </div>
      <div>
        <h4>Lorem ipsum dolor sit amet consectetur adipisicing elit.</h4>
        <p>
          It is a long established fact that a reader will be distracted by the
          readable content of a page when looking a layout. The point of using
          Lorem Ipsum is that it has a more-or-less normal distribution of
          letters, as opposed to using 'Content here, content here', making it
          look like readable English. <br />
          <br /> Lorem ipsum dolor sit, amet consectetur adipisicing elit. Sint
          officiis nihil accusantium ducimus repellat commodi magni quam
          inventore temporibus cumque! Reprehenderit earum obcaecati, ut
          consequatur praesentium tempore suscipit eveniet ducimus!
        </p>
      </div>
      <div>
        <h4>Make perfect organic product with us</h4>
        <p>
          Lorem ipsum dolor sit, amet consectetur adipisicing elit. Sint
          officiis nihil accusantium ducimus repellat commodi magni quam
          inventore temporibus cumque! Reprehenderit earum obcaecati, ut
          consequatur praesentium tempore suscipit eveniet ducimus! <br />
          <br />
          It is a long established fact that a reader will be distracted by the
          readable content of a page when looking a layout. The point of using
          Lorem Ipsum is that it has a more-or-less normal distribution of
          letters, as opposed to using 'Content here, content here', making it
          look like readable English.
        </p>
      </div>
    </NewsInfoContainer>
  );
};

export default NewsInfo;
